<div class="header">
  @if (activityState) {
    <h1>{{ activityId }}</h1>
  }
  @if (!activityState) {
    <h1>Enter an activity ID</h1>
  }
</div>
<div class="container">
  @if (!activity) {
    <div>
      <form onsubmit="findActivity()">
        <label for="activityId">Activity ID</label>
        <input
          type="text"
          name="activityId"
          id="activityId"
          [(ngModel)]="activityId" />
        <button class="button-primary" (click)="findActivity()">Find</button>
      </form>
    </div>
  }
  @if (activity) {
    <div>
      @if (activityState) {
        <div>
          <div class="flex-container flex-col">
            <label for="currStepSelect">
              Current Step
              <select
                name="currStepSelect"
                id="currStepSelect"
                [(ngModel)]="activityState.currentStep"
                (change)="currStepChanged()">
                @for (step of steps; track step; let i = $index) {
                  <option [value]="i">
                    {{ step }}
                  </option>
                }
              </select>
            </label>
            <label for="videoProgression">
              Video Progression
              <input
                type="text"
                name="videoProgression"
                id="videoProgression"
                [(ngModel)]="videoProgression" />
            </label>
            <label for="videoTotalWatchTime">
              Video Total Watch Time
              <input
                type="text"
                name="videoTotalWatchTime"
                id="videoTotalWatchTime"
                [(ngModel)]="videoTotalWatchedTime" />
            </label>
            <label for="videoWatchedFully">
              Video Watched Fully?
              <input
                type="checkbox"
                name="videoWachedFully"
                id="videoWatchedFully"
                [(ngModel)]="videoWatchedFully" />
            </label>
            <label for="elapsedTime">
              Elapsed Time
              <input
                type="text"
                name="elapsedTime"
                id="elapsedTime"
                [(ngModel)]="activityState.elapsedTime" />
            </label>
          </div>
          <div>
            <h2>Populations</h2>
            @for (
              pop of activity.populations.slice(0, maxPopsAvailable);
              track pop;
              let i = $index
            ) {
              <div>
                <h2>{{ i + 1 }}</h2>
                <h4>
                  {{ getPopQuestion(pop) }}
                </h4>
                <div class="answers">
                  @if (
                    pop.templateID === templateIdEnum.MULTI_SELECT ||
                    pop.templateID === templateIdEnum.MULTI_SELECT_IMAGE
                  ) {
                    <div class="answers">
                      @for (
                        answer of getMultiChoiceAnswerChoices(pop);
                        track answer
                      ) {
                        <label>
                          <input
                            type="checkbox"
                            [name]="pop.id"
                            [id]="pop.id"
                            (change)="
                              answerChanged(i, [answer.id ?? ''], $event)
                            " />
                          @if (pop.templateID === templateIdEnum.MULTI_SELECT) {
                            <p>
                              {{ answer.choice.texts?.at(0)?.text }}
                            </p>
                          }
                          @if (
                            pop.templateID === templateIdEnum.MULTI_SELECT_IMAGE
                          ) {
                            <img
                              [src]="
                                answer.choice.images?.at(0)?.url ?? ''
                                  | cdnSrcBaseUrl
                              "
                              alt="" />
                          }
                        </label>
                      }
                    </div>
                  }
                  @if (
                    pop.templateID === templateIdEnum.MULTIPLE_CHOICE ||
                    pop.templateID === templateIdEnum.MULTIPLE_CHOICE_IMAGE ||
                    pop.templateID === templateIdEnum.TRUE_FALSE_CHOICE
                  ) {
                    <div class="answers">
                      @for (
                        answer of getMultiChoiceAnswerChoices(pop);
                        track answer
                      ) {
                        <label>
                          <input
                            type="radio"
                            [name]="pop.id"
                            [id]="pop.id"
                            (change)="
                              answerChanged(i, [answer.id ?? ''], $event)
                            " />
                          @if (
                            pop.templateID === templateIdEnum.MULTIPLE_CHOICE ||
                            pop.templateID === templateIdEnum.TRUE_FALSE_CHOICE
                          ) {
                            <p>
                              {{ answer.choice.texts?.at(0)?.text }}
                            </p>
                          }
                          @if (
                            pop.templateID ===
                            templateIdEnum.MULTIPLE_CHOICE_IMAGE
                          ) {
                            <img
                              [src]="
                                answer.choice.images?.at(0)?.url ?? ''
                                  | cdnSrcBaseUrl
                              "
                              alt="" />
                          }
                        </label>
                      }
                    </div>
                  }
                  @if (pop.templateID === templateIdEnum.INLINE_CHOICE) {
                    <div class="answers">
                      @for (
                        answer of getInlineAnswerChoices(pop);
                        track answer;
                        let f = $index
                      ) {
                        <div>
                          @if (answer.choice.texts; as texts) {
                            <div>
                              <label>
                                <select
                                  [name]="pop.id + answer.id"
                                  [id]="pop.id + answer.id"
                                  (change)="textAnswerChanged($event, i, f)">
                                  <option disabled selected></option>
                                  @for (choiceText of texts; track choiceText) {
                                    <option
                                      [value]="choiceText.id"
                                      [id]="pop.id + choiceText.id">
                                      {{ choiceText.text }}
                                    </option>
                                  }
                                </select>
                                <p></p>
                              </label>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (pop.templateID === templateIdEnum.TEXT_ENTRY) {
                    <div class="answers">
                      @for (
                        answer of getTextEntryAnswer(pop);
                        track answer;
                        let f = $index
                      ) {
                        <div>
                          @if (answer; as texts) {
                            <div>
                              <label>
                                <input
                                  type="text"
                                  value=""
                                  (input)="textAnswerChanged($event, i, f)" />
                                <p>Entry {{ f }}</p>
                              </label>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="thin-separator"></div>
                <div>
                  <h4>Attempts:</h4>
                  @for (
                    response of activityState.populationResponses[i].responses;
                    track response;
                    let j = $index
                  ) {
                    <p>Attempt {{ j + 1 }}: {{ response }}</p>
                  }
                  <p>
                    Elapsed Time:
                    {{ activityState.populationResponses[i].elapsedTime }}
                  </p>
                </div>
                <div class="thin-separator"></div>
                <label>
                  Elapsed Time:
                  <input
                    type="text"
                    name="elapsedTime"
                    id="elapsedTime"
                    (change)="elapsedTimeChange($event, i)" />
                </label>
                <button (click)="addAttempt(i)">Add Attempt</button>
                <div class="separator"></div>
              </div>
            }
          </div>
          <div>
            <label for="exportToClipboard">Export to Clipboard</label>
            <input
              type="checkbox"
              name="exportToClipboard"
              id="exportToClipboard"
              [(ngModel)]="exportToClipboard" />
            <button class="button-secondary" (click)="exportSaveState()">
              Export
            </button>
          </div>
          <button class="button-primary" (click)="launchSaveState()">
            Launch
          </button>
          <button class="button-accent" (click)="resetActivity()">
            Start Over
          </button>
        </div>
      }
    </div>
  }
</div>
